export enum ForgotPasswordMessages {
  forgotPasswordRequiredEmail = "forgotPassword.required.email",
  forgotPasswordInvalidEmail = "forgotPassword.invalid.email",
  forgotPasswordTitlePage = "forgotPassword.title.page",
  forgotPasswordEmailLabel = "forgotPassword.email.label",
  forgotPasswordButton = "forgotPassword.button"
}

export interface TranslationForgotPasswordMessages {
  [ForgotPasswordMessages.forgotPasswordRequiredEmail]: string;
  [ForgotPasswordMessages.forgotPasswordInvalidEmail]: string;
  [ForgotPasswordMessages.forgotPasswordTitlePage]: string;
  [ForgotPasswordMessages.forgotPasswordEmailLabel]: string;
  [ForgotPasswordMessages.forgotPasswordButton]: string;
}
